export enum SectionItemListTypeEnum {
  Latest = 'latest',
  Recommended = 'recommended',
  Popular = 'popular',
  Tag = 'tags',
  Courses = 'courses',
  Saved = 'saved',
  History = 'history',
  Section = 'section',
}
